import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function HomeAbout() {
  return <section id="about" className="py-24 bg-cream overflow-hidden" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-160">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative max-w-md mx-auto lg:max-w-none w-full" data-id="element-161">
            <div className="absolute inset-0 bg-warm-brown rounded-2xl translate-x-4 translate-y-4 md:translate-x-6 md:translate-y-6" data-id="element-162"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4xqsUeWmPjM9HmcsPxbT1J/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision..jpg" alt="About Rozii African Hair Braiding" className="relative z-10 w-full aspect-[4/5] object-cover rounded-2xl shadow-lg" data-id="element-163" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-164">
            <h2 className="font-display text-4xl md:text-5xl text-warm-brown mb-6" data-id="element-165">
              About <span className="italic" data-id="element-166">Rozii</span>
            </h2>
            <p className="text-near-black/80 font-body text-base leading-relaxed mb-4" data-id="element-167">
              Braiding isn't just a hairstyle — it's a legacy.
            </p>
            <p className="text-near-black/70 font-body text-base leading-relaxed mb-8" data-id="element-168">
              At Rozii, we celebrate the art, care, and culture behind every
              braid. From luxury braided wigs to custom in-studio styles, we're
              here to help you express your beauty, protect your crown, and wear
              your roots with pride.
            </p>
            <Link to="/about" className="inline-flex items-center justify-center px-8 py-3 bg-brand-gold text-cream font-bold text-sm rounded-full hover:bg-near-black transition-colors shadow-md" data-id="element-169">
              Read About Us
            </Link>
          </motion.div>
        </div>
      </div>
    </section>;
}